import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import Authorise from "@/views/authorise";

// 配置项
const routes = [
  {
    path: "/",
    redirect: "/authorise",
  },
  {
    path: "/authorise",
    component: Authorise,
    meta: {
      title: "授权登录",
    },
  },
  {
    path: "/home",
    component: () => import("@/views/home"),
    meta: {
      title: "首页",
    },
  },
  // {
  //   path: "/login",
  //   component: () => import("@/views/login"),
  //   meta: {
  //     title: "登录",
  //   },
  // },
  {
    path: "/person_examine",
    component: () => import("@/views/person_examine"),
    meta: {
      title: "个人体检",
    },
  },
  {
    path: "/my_order",
    component: () => import("@/views/my_order"),
    meta: {
      title: "我的订单",
    },
  },
  {
    path: "/confirm_arrange",
    component: () => import("@/views/confirm_arrange"),
    meta: {
      title: "预约确认",
    },
  },
  {
    path: "/work_examine",
    component: () => import("@/views/work_examine"),
    meta: {
      title: "从业体检",
    },
  },
  {
    path: "/examine_details",
    component: () => import("@/views/examine_details"),
    meta: {
      title: "套餐详情",
    },
  },
  {
    path: "/examine_personsList",
    component: () => import("@/views/examine_personsList"),
    meta: {
      title: "体检人信息",
    },
  },
  {
    path: "/register_person",
    component: () => import("@/views/register_person"),
    meta: {
      title: "新增体检人",
    },
  },
  {
    path: "/setmeal_list",
    component: () => import("@/views/setmeal_list"),
    meta: {
      title: "套餐选择",
    },
  },
  {
    path: "/pay_package",
    component: () => import("@/views/pay_package"),
    meta: {
      title: "确认订单",
    },
  },
  {
    path: "/intention_reg",
    component: () => import("@/views/intention_reg"),
    meta: {
      title: "意向登记",
    },
  },
  {
    path: "/intention_list",
    component: () => import("@/views/intention_list"),
    meta: {
      title: "意向登记记录",
    },
  },
  {
    path: "/report",
    component: () => import("@/views/report"),
    meta: {
      title: "体检报告",
    },
  },
  {
    path: "/report_info",
    component: () => import("@/views/report_info"),
    meta: {
      title: "体检报告详情",
    },
  },
  {
    path: "/cashier_desk",
    component: () => import("@/views/cashier_desk"),
    meta: {
      title: "收银台",
    },
  },
  {
    path: "/orderInfo",
    component: () => import("@/views/orderInfo"),
    meta: {
      title: "订单信息",
    },
  },
  {
    path: "/need_konw",
    component: () => import("@/views/need_konw"),
    meta: {
      title: "体检须知",
    },
  },
  {
    path: "/workInfo",
    component: () => import("@/views/workInfo"),
    meta: {
      title: "填写个人信息",
    },
  },
];

// 创建实例
const router = new VueRouter({
  routes,
});

// 导出实列

export default router;
